import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { useTooltipPositioning } from "./UseTooltipPositioning";
import { styles } from "./PromptPreviewStyles";
import { markdownStyles } from "./MarkdownStyles";

const PromptPreview = ({ value, paddingBottom = 28 }) => {
  const { previewContainerRef } = useTooltipPositioning(value);

  const enhanceContent = (content) => {
    if (!content) return "";
    return `<style>${styles}</style>${content}`;
  };

  return (
    <div
      className="prompt-preview-wrapper"
      style={{
        height: `calc(100% - ${paddingBottom}px)`,
        position: "relative",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <div
        className="monaco-scrollable-element editor-scrollable dark-slim-scrollbar"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "auto",
          backgroundColor: "#1E1E1E",
        }}
        ref={previewContainerRef}
      >
        <div
          className="markdown-preview"
          style={{
            padding: "20px",
            paddingTop: "20px",
            fontFamily: "'Menlo', 'Monaco', 'Courier New', monospace",
            fontSize: "14px",
            lineHeight: "1.5",
            color: "#D4D4D4",
          }}
        >
          <style>{markdownStyles}</style>
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>
            {enhanceContent(value)}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default PromptPreview;
